<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="PAs:"
    id="selectPA"
    placeholder="Selecione o(s) PA(s)"
    :multiple="multiple"
    @update:value="handleValueUpdate"
  ></NxSelectReduced>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import PARepository from '../../../../shared/http/repositories/configurations/pa'
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectPA',
  mixins: [useReactiveModelMixin('value')],
  props: {
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadPAs()
  },
  methods: {
    onLoadPAs () {
      PARepository.GetAll()
        .then((response) => {
          if (response.data && response.data.content && Array.isArray(response.data.content)) {
            // Filtrar PAs válidos (com numero e descricao não nulos)
            let validPAs = response.data.content.filter(pa =>
              pa.numero !== null &&
              pa.numero !== undefined &&
              pa.descricao !== null &&
              pa.descricao !== undefined &&
              pa.descricao.trim() !== ''
            )

            let result = validPAs.map((x) => ({
              value: x.numero,
              text: x.descricao
            }))
            this.listOptions = result
          } else {
            console.error('Estrutura de resposta inválida:', response.data)
            this.listOptions = []
          }
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de PAs', 'Erro')
          console.error('Erro ao carregar PAs:', err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectPA.vue